import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      // backgroundColor: 'red'
    },
    wrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      outline: "none",
      gap: 10,
      width: "100%",
      maxWidth: 900,
      boxSizing: "border-box",
      maxHeight: "90vh",
      overflow: "hidden",
      [theme.breakpoints.down("sm")]: {
        margin: theme.spacing(1),
      },
    },
    header: {
      display: "flex",
      width: '100%',
      backgroundColor: colors.white,
      alignItems: "center",
      borderRadius: 5,
      padding: 30,
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      }
    },
    headerTitle: {
      fontSize: '2em !important',
      color: colors.blueDark,
      fontWeight: 'bold',
    },
    content: {
      display: "flex",
      width: '100%',
      height: '80%',
      backgroundColor: colors.white,
      flexDirection: 'column',
      boxSizing: 'border-box',
      borderRadius: 5,
    },
    body: {
      display: "flex",
      width: '100%',
      height: '100%',
      // alignItems: "center",
      padding: 30,
      boxSizing: 'border-box',
      overflowY: 'auto',
      // ensure body scrolls when content exceeds modal height
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      }
    },
    footer: {
      display: "flex",
      width: '100%',
      // alignItems: "center",
      borderTop: `1px solid ${colors.gray}`,
      padding: 30,
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        padding: 12,
      }
    },
    footerContainerButton: {
      display: "flex",
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 10,
      width: '100%',
    },
    buttonPrimary: {
      backgroundColor: colors.purple,
      color: colors.white
    },
    buttonSecondary: {
      backgroundColor: colors.white,
      color: colors.purple
    }
  }),
)
